
const parseESResponse = (response) => {
  const groups = response.hits.hits.map(hit => {
    return hit._source;
  });
  return { groups };
};

module.exports = parseESResponse;



// WEBPACK FOOTER //
// ./app/assets/js/lib/parseESResponse.js